import type { Integration, IntegrationType } from "store/user/userConstants";
import type { SupportedSocialCardKey } from "../types";

export const getIntegrationDetails = (
  integrations: (Omit<Integration, "type"> & { type: IntegrationType })[],
  type: SupportedSocialCardKey | undefined
): (Omit<Integration, "type"> & { type: IntegrationType }) | undefined => {
  if (!type) return undefined;
  // Simply find the integration that matches the requested type.
  return integrations.find((social) => social.type === type);
};
